import {FC} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Icon from 'components/Icon';
import Link from 'components/Link';
import {useBackend} from 'state/backend';
import {ClientInboxItemBackend} from '../../types';

const LoginMakeLeaps: FC = () => {
    const {t} = useTranslation('Portal');
    const {
        data: {loggedInPartner},
    } = useBackend<ClientInboxItemBackend>();
    const next = window.location.href.split('?')[0];

    if (loggedInPartner?.mid) return undefined;

    return (
        <div>
            <div className="my-4 text-sm flex justify-center">
                <div>
                    <Trans
                        className="block"
                        components={[
                            <Link key="0" href={`/user/login/?next=${next}`}>
                                {' '}
                            </Link>,
                        ]}
                        i18nKey="clientInboxItem.loginToMakeLeaps.login"
                        t={t}
                    />
                </div>
            </div>
            <div className="bg-grey-200 text-grey-500 text-xs p-2 flex gap-x-1 rounded-md mx-auto w-fit">
                <Icon className="inline" icon="info_solid" size="base" />
                <div className="flex-1 min-w-0">
                    {t('clientInboxItem.loginToMakeLeaps.salesForce')}
                </div>
            </div>
        </div>
    );
};

export default LoginMakeLeaps;
